module.exports = __webpack_public_path__ + "img/rec_3.a3c91e0e.png";